import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";

export type BorderedContentProps = {
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export const BorderedContent: React.FC<BorderedContentProps> = ({
  header,
  children,
  className,
}) => {
  const scaffold = useScaffold();
  return (
    <div
      className={clsx(
        "flex flex-col border rounded-xl p-4",
        scaffold.page.colors.border.plain,
        className,
      )}
    >
      {header && (
        <div
          className={clsx(
            "text-[12px] font-medium leading-[30px]",
            scaffold.page.colors.text.secondary,
          )}
        >
          {header}
        </div>
      )}
      {children}
    </div>
  );
};
